module.exports = __webpack_public_path__ + "cd995d7d416353f66dc1966a959a3471.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chipotle_2022_chart.png
// module id = 1652
// module chunks = 0